import { Component, inject, signal } from '@angular/core';
import { OrderReferenceService } from '../../../shared/services/order-reference.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GetOrdersByConfirmResponse } from '../../interfaces/get-orders-by-confirm.response';
import { map, tap } from 'rxjs';
import { OrdersConfirmByUserRequest } from '../../interfaces/orders-confirm-by-user.request';

@Component({
  selector: 'app-modal-orders-by-confirm',
  imports: [],
  templateUrl: './modal-orders-by-confirm.component.html',
  styles: ``,
})
export class ModalOrdersByConfirmComponent {
  private orderReferenceService = inject(OrderReferenceService);
  private ngbActiveModal = inject(NgbActiveModal);

  ordersByConfirm = signal<GetOrdersByConfirmResponse[]>([]);
  selectedIds = signal<string[]>([]);

  isAnyConfirm = signal(true);

  toggleArticle(id: string, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;

    this.selectedIds.update((current) => {
      if (checked) {
        return [...current, id];
      }

      return current.filter((x) => x !== id);
    });
  }

  confirmOrders() {
    this.isAnyConfirm.set(this.selectedIds().length > 0);

    if (!this.isAnyConfirm()) {
      setTimeout(() => this.isAnyConfirm.set(true), 2000);
      return;
    }

    const request: OrdersConfirmByUserRequest = {
      orderDetailId: this.selectedIds(),
    };
    this.orderReferenceService.ordersConfirmByUser(request).subscribe({
      // next: (isSuccess) => {
      //   console.log(isSuccess);
      // },
      complete: () => this.closeModal(),
    });
  }

  closeModal() {
    this.ngbActiveModal.close();
  }
}
